<template lang="html">
  <div class="nav-wrap">
    <div class="nav-bar">
      <!-- <div class="nav-member" v-if="!logined && (level >=0 )">
        <a href="javascript:;" class="icon-member">
          <i :class="'icon-m-' + level"></i>
          <span class="nav-member-rate">99折</span>
        </a>
      </div> -->
      <div class="nav-kinds" :class="'no-member'">
        <div class="nav-item"
          v-for="(item, index) in navName"
          :class="{
            active: index == curActive
          }"
          @click="selectNav(navType[index], index, $event)">
          {{ item }}
          <span class="icon-sort" v-if="navType[index] === 'PRICE'">
            <i :class="{
              'icon-kinds': navType[index] == 'FILTER',
              'active': isKindActive
              }">
            </i>
          </span>
        </div>
      </div>
      <slide
        from="right"
        height="100%"
        :show="showSlide"
        :maskOpacity="0">
        <nav-list 
          v-if="selectObject" 
          :discountSelected="discountSelected"
          :selectObject="selectObject" 
          :clearFilter="clearFilter"
          @select="onSelect"/>
      </slide>
    </div>
    <div class="top-tip" v-if="tips">{{tips}}</div>
    <div class="label-tag"
      :class="{
        valid: !label.valid
      }"
      v-if="label">
      <div class="tag-name" 
        :style="{
          'background-color': label.typeBgColor,
          'color': label.typeColor
        }"
      >{{label.type}}</div>
      <div class="tag-desc">{{label.summary}}</div>
      <div class="tag-link" 
        v-if="label.jump"
        @click="labelJump(label)">{{label.linkDesc}}<i></i></div>
    </div>
  </div>
</template>

<script>
import Slide from '@/components/slide'

import navList from './components/nav'
import {
  getMember
} from './apis'

const NAV_NAME = ['综合', '新品', '价格', '筛选']
const NAV_TYPE = ['SYNTHESIS', 'RELEASE', 'PRICE', 'FILTER']
const ENUM_SORT = ['DEFAULT', 'ASC', 'DESC', '']

export default {
  name: 'navBar',

  components: {
    Slide,
    navList
  },

  props: ['query', 'clearFilter', 'type', 'new', 'label', 'discountSelected', 'tips', 'sortField'],

  data () {
    return {
      navName: NAV_NAME,
      navType: NAV_TYPE,
      logined: false,
      level: 0,
      isDesc: false,
      showSlide: false,
      sort: 1,
      curActive: NAV_TYPE.indexOf(this.sortField) || 0,
      sortField: this.sortField || 'SYNTHESIS',
      sortOrder: 'DEFAULT',
      isKindActive: false,
      selected: {},
      selectObject: null,
      selectQuery: {
        cateSelected: '',
        brandSelected: '',
        hotSelected: ''
      },
    }
  },

  created () {
    if (this.new == 1) {
      this.sortField = 'RELEASE'
      this.curActive = 1
    }
  },

  methods: {
    show (selected) {
      this.selectObject = {
        que: this.query,
        selected
      }

      this.$nextTick(() => {
        this.showSlide = true
      })

      this.$emit('navshow', selected)
    },

    selectNav (type, index, e) {
      const tar = e.currentTarget
  
      if (type === 'FILTER') {
        if (this.clearFilter) {
          this.selectQuery = {
            cateSelected: '',
            brandSelected: '',
            hotSelected: ''
          }
        }

        const {
          cateSelected,
          brandSelected,
          hotSelected
        } = this.selectQuery

        this.show(`${cateSelected},${brandSelected},${hotSelected}`)
      }
      else {
        // init sort
        if (type === this.sortField && type !== 'PRICE') return
        if (type !== this.sortField) {
          this.sortField = type
          this.sort = 2
        }
        else if (type === this.sortField && type !== 'PRICE') {
          this.sort = 2
          // if (this.type === 'search' && this.sortField) {
          //   this.sortField = ''
          //   this.sort = 3
          //   type = ''
          //   index = -1
          // }
          // else {
           
          // }
        }

        this.curActive = index  

        this.$nextTick(() => {
          if (type === 'PRICE') {       
            this.sort = this.sort - 1

            if (this.sort === 3) {
              type = ''
              this.curActive = -1
            }
            // set sort
            tar.classList.remove('DESC')
            tar.classList.remove('ASC')
            if (ENUM_SORT[this.sort]) {
              tar.classList.add(ENUM_SORT[this.sort])
            }
            
          }
          
          this.$emit('action', type, ENUM_SORT[this.sort])

          if (this.type !== 'search') {
            this.sort = this.sort == 1 ? 3 : this.sort
          }
          else {
            if (this.sort == 2) {
              this.sort = 2
            }
            else if (this.sort == 3) {
              this.sort = 2
            }
            else {
              this.sort = this.sort == 1 ? 3 : this.sort
            }
          }
        })

      }
    },

    labelJump (label) {
      let title = ''

      if (label.linkDesc) {
        title = label.linkDesc.replace(/查看/, '')
      }

      window.location.href = `${label.link}&title=${encodeURIComponent(title)}` 
    },

    onSelect (query, selected, saleSelected, isSelected) {
      if (query) {
        this.isKindActive = true
      }
      else {
        this.isKindActive = false
      }

      const _filter = document.querySelectorAll('.nav-item')[3]
      console.log(isSelected, '123')
      if (isSelected|| saleSelected) {
        _filter.classList.add('active')
      }
      else {
        _filter.classList.remove('active')
      }
    

      this.showSlide = false
      this.$emit('list', query, saleSelected)
    }
  }
}
</script>

<style lang="stylus">
@import "./index"
</style>



// WEBPACK FOOTER //
// index.vue?7ec864a8